import { IExclusivityAvailabilityState } from '../../../faire/exclusivity_agreement/client/IExclusivityAvailabilityState';
import { IFaireMoney } from '../../../indigofair/data/IFaireMoney';

export namespace IGetRetailerExclusivityAvailabilityWithBrandResponse {
  export namespace IExclusivityAvailabilityOption {
    export enum ExclusivityAvailabilityType {
      EXCLUSIVITY_AVAILABILITY_TYPE_UNKNOWN = 'EXCLUSIVITY_AVAILABILITY_TYPE_UNKNOWN',
      GLOBAL_MINIMUM = 'GLOBAL_MINIMUM',
      REQUESTS = 'REQUESTS',
    }

    /**
     * Return an instance of IExclusivityAvailabilityOption with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IExclusivityAvailabilityOption>
    ): IExclusivityAvailabilityOption =>
      ({
        ...(partial ?? {}),
      }) as IExclusivityAvailabilityOption;
  }

  export interface IExclusivityAvailabilityOption {
    exclusivity_availability_type:
      | keyof typeof IGetRetailerExclusivityAvailabilityWithBrandResponse.IExclusivityAvailabilityOption.ExclusivityAvailabilityType
      | undefined;
    exclusivity_minimum_amount: IFaireMoney | undefined;
  }

  /**
   * Return an instance of IGetRetailerExclusivityAvailabilityWithBrandResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetRetailerExclusivityAvailabilityWithBrandResponse>
  ): IGetRetailerExclusivityAvailabilityWithBrandResponse =>
    ({
      exclusivity_availability_options: [],
      ...(partial ?? {}),
    }) as IGetRetailerExclusivityAvailabilityWithBrandResponse;
}

export interface IGetRetailerExclusivityAvailabilityWithBrandResponse {
  state: keyof typeof IExclusivityAvailabilityState.State | undefined;
  expires_at: number | undefined;
  commitment_spend: IFaireMoney | undefined;
  commitment_balance_left_to_spend: IFaireMoney | undefined;
  start_at: number | undefined;
  /**
   * @protobufOption (.faire.common.tokenType) = EXCLUSIVITY_AGREEMENT
   */
  exclusivity_agreement_token: string | undefined;
  has_active_exclusivity_agreement: boolean | undefined;
  /**
   * @deprecated
   */
  has_post_active_agreement_with_brand: boolean | undefined;
  exclusivity_availability_options: Array<IGetRetailerExclusivityAvailabilityWithBrandResponse.IExclusivityAvailabilityOption>;
  retailer_requested_commitment_spend: IFaireMoney | undefined;
  brand_counter_offer_commitment_spend: IFaireMoney | undefined;
}
